import { useWebSocket } from '@/contexts/connections'
import { AppDispatch, Message as M, RootState, UserData } from '@/types'
import {
  recieveMessage,
  switchRoomAndFetchMessages,
} from '@store/messages/messages.actions'
import { FormEvent, useEffect, useRef, useState } from 'react'
import useAuthUser from 'react-auth-kit/hooks/useAuthUser'
import { useDispatch, useSelector } from 'react-redux'
import Message from './Message'

const EMPTY_ARRAY: [] = []

const Chat = () => {
  const [input, setInput] = useState('')

  const dispatch = useDispatch<AppDispatch>()
  const userData = useAuthUser<UserData>()
  const socketContext = useWebSocket()

  const currentRoomId = useSelector(
    (state: RootState) => state.rooms.selectedRoomId
  )
  const currentChannelId = useSelector(
    (state: RootState) => state.channels.selectedChannelId
  )
  const messages = useSelector(
    (state: RootState) => state.messages.rooms[currentRoomId] || EMPTY_ARRAY
  )

  const chatContainerRef = useRef(null)

  const sendMessage = (e: FormEvent) => {
    e.preventDefault()
    if (input.trim() === '') return
    const newMessage = {
      type: 'chat-message',
      content: input,
      sender_id: userData?.user_id,
      sender_name: userData?.email,
      room_id: currentRoomId,
      timestamp: new Date().toISOString(),
    }

    socketContext?.sendWebSocketMessage(newMessage)
    setInput('')
  }

  useEffect(() => {
    const eventHandler = (e: MessageEvent) => {
      const message = JSON.parse(e.data)
      // TODO: Change type for chat messages
      if (message.type == 'chat-message') {
        dispatch(recieveMessage(currentRoomId, message))
      }
    }
    const socket = socketContext?.socket
    if (socket) {
      console.log('Starting listener')
      socket.addEventListener('message', eventHandler)
    }

    return () => {
      if (socket) {
        socket.removeEventListener('message', eventHandler)
      }
    }
  }, [currentRoomId, socketContext, dispatch])

  useEffect(() => {
    if (currentRoomId && currentChannelId) {
      console.log('switching room and fetching messages')
      dispatch(switchRoomAndFetchMessages(currentRoomId))
    }
  }, [currentRoomId, currentChannelId, dispatch])

  return (
    <div className="m-auto p-5 bg-gray-100 rounded-lg shadow-lg h-full">
      <h1 className="text-2xl font-bold mb-5">Chat</h1>
      <div
        className="flex flex-col-reverse bg-white rounded-lg p-3 overflow-y-auto h-[91%]"
        ref={chatContainerRef}
      >
        {messages.map((message: M) => (
          <Message
            message={message}
            key={message.id}
            root={chatContainerRef.current}
          />
        ))}
      </div>

      <div className="flex mt-3">
        <form onSubmit={(e) => sendMessage(e)} className="flex w-full">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message..."
            className="w-full p-4 text-[18px] border border-gray-300 rounded-l-md mx-2"
          />
          <button
            type="submit"
            className="
		bg-primary
		p-4
		text-secondary
		font-normal
		text-2xl
		rounded
		cursor-pointer
		hover:bg-primary-dark
	    "
            disabled={!input.trim()}
          >
            Send
          </button>
        </form>
      </div>
    </div>
  )
}

export default Chat
